import { OrderedMap } from "immutable";

import {
  GET_TRENDING_TOPICS_REQUESTED,
  GET_TRENDING_TOPICS_SUCCEEDED,
  GET_TAGS_REQUESTED,
  GET_TAGS_SUCCEEDED,
  GET_TAGS_NEXT_PAGE_SUCCEEDED,
  TOGGLE_TAG_SELECTION,
  RESET_TAG_STATE,
} from "settings/actions/tags";

const initialState = {
  tags: OrderedMap(),
  trendingTopics: OrderedMap(),
  selected: {},
  isLoadingTags: true,
  isLoadingTrendingTopics: true,
  meta: {
    filter: {},
  },
};

const arrayOfTagsToOrderedMap = results => {
  return OrderedMap(results.map(result => [result.id, result]));
};

const arrayOfTrendingTopicsToOrderedMap = results => {
  return OrderedMap(
    results.map(result => {
      if (result.recent_stories > 0) {
        return [result.id, result];
      }
    })
  );
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TAGS_REQUESTED:
      return {
        ...state,
        isLoadingTags: true,
        meta: { ...state.meta, filter: action.payload },
      };
    case GET_TRENDING_TOPICS_REQUESTED:
      return {
        ...state,
        isLoadingTrendingTopics: true,
      };
    case GET_TRENDING_TOPICS_SUCCEEDED:
      return {
        ...state,
        trendingTopics: arrayOfTrendingTopicsToOrderedMap(
          action.payload.results
        ),
        isLoadingTrendingTopics: false,
      };
    case GET_TAGS_SUCCEEDED:
      return {
        ...state,
        tags: arrayOfTagsToOrderedMap(action.payload.results),
        meta: { ...state.meta, response: action.payload },
        isLoadingTags: false,
      };
    case GET_TAGS_NEXT_PAGE_SUCCEEDED:
      return {
        ...state,
        tags: state.tags.merge(arrayOfTagsToOrderedMap(action.payload.results)),
        meta: { ...state.meta, response: action.payload },
      };
    case TOGGLE_TAG_SELECTION:
      return {
        ...state,
        selected: {
          ...state.selected,
          [action.payload.id]: !state.selected[action.payload.id],
        },
      };
    case RESET_TAG_STATE:
      return initialState;
    default:
      return state;
  }
};
